import api from './api';
import { Draw, DrawWinner } from '../types';

export const drawService = {
  async getAllDraws(options?: { limit?: number; campaignId?: string }): Promise<Draw[]> {
    const response = await api.get('/draws', {
      params: {
        limit: options?.limit ?? 100,
        ...(options?.campaignId ? { campaignId: options.campaignId } : {}),
      },
    });
    return response.data.draws || [];
  },

  async getDrawById(id: string): Promise<Draw> {
    const response = await api.get(`/draws/${id}`);
    return response.data;
  },

  async createDraw(draw: Omit<Draw, 'id' | 'status' | 'createdAt' | 'updatedAt'>): Promise<Draw> {
    const response = await api.post('/draws', draw);
    return response.data;
  },

  async updateDraw(id: string, draw: Partial<Draw>): Promise<Draw> {
    const response = await api.put(`/draws/${id}`, draw);
    return response.data;
  },

  async deleteDraw(id: string): Promise<void> {
    await api.delete(`/draws/${id}`);
  },

  async getDrawsByCampaign(campaignId: string): Promise<Draw[]> {
    const response = await api.get(`/draws/campaign/${campaignId}`);
    return response.data;
  },

  async executeDraw(id: string): Promise<DrawWinner[]> {
    const response = await api.post(`/draws/${id}/perform`);
    return response.data;
  },

  async getDrawWinners(id: string, status?: string): Promise<DrawWinner[]> {
    const params = status ? { status } : {};
    const response = await api.get(`/draws/${id}/winners`, { params });
    return response.data;
  },

  async approveWinner(drawId: string, winnerId: string): Promise<DrawWinner> {
    const response = await api.patch(`/draws/${drawId}/winners/${winnerId}/approve`);
    return response.data;
  },

  async rejectWinner(drawId: string, winnerId: string, reason?: string): Promise<DrawWinner> {
    const response = await api.patch(`/draws/${drawId}/winners/${winnerId}/reject`, { reason });
    return response.data;
  }
}; 